<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年月" prop="year">
                <el-date-picker
                    style="width: 100%;"
                    v-model="q.date"
                    type="month"
                    value-format="yyyyMM"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="经销商" prop="agentCode">
                <el-input v-model="q.oneLevelAgent" placeholder="请输入一级经销商编码或名称"></el-input>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">

                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="530"
        >
          <el-table-column
              prop="year"
              :show-overflow-tooltip="true"
              label="年"
              width="100"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="month"
              :show-overflow-tooltip="true"
              label="月"
              width="100"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="oneLevelAgent"
              :show-overflow-tooltip="true"
              label="一级经销商编码"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgent }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oneLevelAgentName"
              :show-overflow-tooltip="true"
              label="一级经销商名称"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="field"
              :show-overflow-tooltip="true"
              label="领域"
              width="150"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.field|dictname('fl_field')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="sales"
              :show-overflow-tooltip="true"
              label="安装量"
              width="150"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">{{ Number(scope.row.sales).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="120"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="chakan(scope.row)">查看明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        oneLevelAgent: '',
        date: new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
    }
  },
  created() {
    this.q = {
      oneLevelAgent: '',
      date: new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.query();
  },
  methods: {
    //重置
    reset() {
      this.q = {
        oneLevelAgent: '',
        date: new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
          this.query();
    },
    //查询table
    query() {
      ss.fanli.selectFxServiceSalesPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fanli/flFxServiceOrder/downloadExcel", this.q, "post");
    },
    //点击查看详情
    chakan(item) {
      console.log('行', item)
      this.$router.push({
        path: '/establish/fxServiceSalesDetailTable',
        query: {
          year: item.year,
          month: item.month,
          field: item.field,
          oneLevelAgent: item.oneLevelAgent,
        }
      });
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
